import { MapSidePanelItemSettings } from './map-side-panel-settings';

export abstract class BaseMapSidePanelComponent {
  itemSettings: MapSidePanelItemSettings<BaseMapSidePanelComponent>;
  mapData: any;
}
